import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { withStyles } from "@material-ui/core/styles";
import { isAfter, subDays, format } from "date-fns";
import Chart_garmin_daily_hr from '../components/Chart_garmin_daily_hr';
import qs from "qs";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import DateFnsUtils from "@date-io/date-fns";
import {
    MuiPickersUtilsProvider,
    TimePicker,
    DatePicker
} from "material-ui-pickers";
import SleepChart from "./SleepChart";
import TableContainer from "@material-ui/core/TableContainer";

const styles = theme => ({
    root: {
        width: "100%",
        marginTop: theme.spacing.unit * 7,
        overflowX: "auto"
    },
    table: {
        minWidth: 700
    },
    grid: {
        marginTop: 40,
        width: "100%",
        alignItems: "center",
        justifyContent: "flex-start"
    },
    button: {
        height: 40,
        margin: theme.spacing.unit
    },
    datePicker: {
        margin: theme.spacing.unit * 2
    },
    container: {
        maxHeight: 1000
    }
});

class Activities extends Component {
    state = {
        date: new Date(),
        users: [],
        data: []
    };

    async getUserResource({ date }) {
        const id = this.props.id;
        try {
            const result = await fetch(
                `/api/getGarminHeartRate?id=${id}&date=${date}`,
                {
                    mode: "cors",
                    method: "GET"
                }
            );

            const data = await result.json();
            console.log("HR:", data)
            // error handling
            this.setState({ data });
        } catch (err) {
            console.log(err);
        }
    }

    componentDidMount() {
        const date =
            qs.parse(this.props.search, { ignoreQueryPrefix: true }).date ||
            format(new Date(), "yyyy-MM-dd");
        this.setState({
            date,
            selectedDate: date
        });
        this.getUserResource({ date });
    }

    handlePickerOnClick = () => {
        let date = this.state.selectedDate;

        // if (isAfter(new Date(start), new Date(end))) {
        //   let tmp = start;
        //   start = end;
        //   end = tmp;
        // }

        window.location = `?date=${date}`;
    };

    handleDateChange = date => {
        this.setState({ selectedDate: format(date, "yyyy-MM-dd") });
    };

    //   handleEndDateChange = date => {
    //     this.setState({ selectedEndDate: format(date, "yyyy-MM-dd") });
    //   };

    render() {
        const { classes } = this.props;
        const { selectedDate, date } = this.state;

        return (
            <div>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Paper>
                        <Grid container className={classes.grid} justify="space-around">
                            <DatePicker
                                margin="normal"
                                label="日期"
                                value={selectedDate}
                                onChange={this.handleDateChange}
                                className={classes.datePicker}
                            />

                            <Button
                                variant="contained"
                                color="primary"
                                className={classes.button}
                                onClick={this.handlePickerOnClick}
                            >
                                搜尋
                            </Button>
                        </Grid>
                    </Paper>
                </MuiPickersUtilsProvider>

                <TableContainer className={classes.container}>
                    <Table stickyHeader className={classes.table}>
                        <div>
                            {(this.state.data.length != 0) && <div style={{ width: "1000px", padding: "10px" }}><Chart_garmin_daily_hr data={this.state.data} date={this.state.date} /></div>}
                        </div>
                    </Table>
                </TableContainer>
            </div>
        );
    }
}

export default withStyles(styles)(Activities);
